import { render, staticRenderFns } from "./CustomerDeliveryStatusesComponent.vue?vue&type=template&id=67fb4658"
import script from "./CustomerDeliveryStatusesComponent.vue?vue&type=script&lang=js"
export * from "./CustomerDeliveryStatusesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports